export class SalesHistoryProduct {
  private ean: string;
  private productName: string;
  private soldItemQuantity: number;
  private soldPrice: number;

  setEan(value: string): void {
    this.ean = value;
  }

  getEan(): string {
    return this.ean;
  }

  setProductName(value: string): void {
    this.productName = value;
  }

  getProductName(): string {
    return this.productName;
  }

  setSoldItemQuantity(value: number): void {
    this.soldItemQuantity = value;
  }

  getSoldItemQuantity(): number {
    return this.soldItemQuantity;
  }

  setSoldPrice(value: number): void {
    this.soldPrice = value;
  }

  getSoldPrice(): number {
    return this.soldPrice;
  }
}
